class Khadamati{
    constructor(json){
        this.id=json.id;
        this.title=json.title;
        this.text=json.text;
        this.img=json.img;
        this.rate=json.rate;
        this.address=json.address;
        this.phone=json.phone;
    }
}

export default Khadamati;